// https://github.com/microsoft/TypeScript/issues/1897#issuecomment-657294463
// Alteration: Added `undefined` to SerializableScalar to capture behavior of the Object type
export function isSerializableObject(object) {
  return typeof object === 'object' && !Array.isArray(object) && object !== null;
}
//# sourceMappingURL=types.js.map